import React, { useEffect } from "react";
import { createUrlWithParams } from "../Widget/Voice";
import { getVoiceWidgetDomain } from "../../utils/common";
import { updateVoiceDimensions } from "../../routes/host-bridge";

export default function VoiceWidget(props) {
	const {
		assistantId,
		botId,
		tenantId,
		uuid,
		originInfo,
		originHost,
		originPath,
	} = props;

	const url = createUrlWithParams(getVoiceWidgetDomain(), {
		assistantId,
		uuid,
		tenantId,
		botId,
		isWidget: true,
		originHost: originHost,
		originPath: originPath,
	});

	const updateWidgetDimensions = () => {
		updateVoiceDimensions();
	};

	useEffect(() => {
		const t = setTimeout(updateWidgetDimensions, 1000);
		return () => clearTimeout(t);
	}, []);

	return (
		<iframe
			src={url}
			allow="microphone *"
			style={{
				border: "none",
				height: "350px",
				width: "400px",
			}}
		/>
	);
}
